'use client';

import {usePathname} from '@components/@nav';
import {useMeQuery} from '@hooks';
import {useLocale} from '@hooks/useLocale';
import {useStableCallback} from '@hooks/useStableCallback';
import {dataLayerEmit} from '@services/gtm/datalayer.service';
import {FC, useEffect} from 'react';

const DataLayerPageLoad: FC = () => {
    const locale = useLocale();
    const pathName = usePathname();

    const {
        query: {data: user},
    } = useMeQuery();

    const submitDataLayerPageLoadEvent = useStableCallback(() => {
        const userAttributes = !user
            ? null
            : {
                  user_id: user.id,
                  email: user.email,
                  planID: user.subscription?.itemPriceId ?? null,
                  country: user.address?.country ?? null,
                  subscriptionOrderDate:
                      user.subscription?.aboOrderDate ?? null,
                  subscriptionStartedAt:
                      user.subscription?.subscriptionActivatedAt ?? null,
                  subscriptionState:
                      user.subscription?.currentSubscriptionState ?? null,
              };

        dataLayerEmit(
            'page_load',
            {
                path: pathName,
                locale: locale,
                ...userAttributes,
            },
            '',
        );
    });

    useEffect(() => {
        submitDataLayerPageLoadEvent();
    }, [pathName, submitDataLayerPageLoadEvent]);

    return null;
};

export default DataLayerPageLoad;
